import { useReactiveVar } from '@apollo/client'
import { Text } from '@radix-ui/themes'
import { featureFlags } from 'app/app-feature-flags'
import { isDemoQuotaConversionVar } from '../store/dialogs'
import styles from '../sign-up.module.scss'

export const AuthDemoQuotaNotice = () => {
  const isDemoQuotaConversion = useReactiveVar(isDemoQuotaConversionVar)

  if (!isDemoQuotaConversion) return null

  const action = featureFlags.isMainNetFeature ? 'Connect a wallet' : 'Sign up'

  return (
    <Text
      size='2'
      align='center'
      className={styles.demoQuotaNotice}
    >
      You have used all free demo games. {action} to keep playing Human vs AI
      with real USDT.
    </Text>
  )
}
